'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsClientChange = exports.selectIsToggleMapView = exports.selectSearchLocationChange = exports.reloadSearch = exports.showAllVenues = exports.loadPage = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.doTrackMapViewToggle = doTrackMapViewToggle;
exports.buildSearchRequestPayload = buildSearchRequestPayload;
exports.resetFilters = resetFilters;
exports.trackSearchQuery = trackSearchQuery;
exports.loadResults = loadResults;
exports.loadResultsFromUrl = loadResultsFromUrl;
exports.doFilterChanged = doFilterChanged;
exports.reloadResults = reloadResults;
exports.handleUrlChange = handleUrlChange;
exports.handleReservationStatusChanged = handleReservationStatusChanged;
exports.handlePageChange = handlePageChange;
exports.hasLocationBeenSet = hasLocationBeenSet;
exports.loadSearchHeader = loadSearchHeader;
exports.initializeUserLocationForSearch = initializeUserLocationForSearch;
exports.loadSearch = loadSearch;
exports.doShowMapForMobileLoggedOut = doShowMapForMobileLoggedOut;
exports.doShowAllVenues = doShowAllVenues;
exports.watchSearch = watchSearch;

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _locale = require('redux/modules/locale');

var _device = require('redux/modules/device');

var _user = require('redux/modules/user');

var _isMobile = require('helpers/isMobile');

var _sagaTools = require('@classpass/saga-tools');

var _filterSets = require('constants/filter-sets');

var _Reservation = require('features/Reservation/Reservation.saga');

var _selectors = require('redux/saga/selectors');

var _time = require('helpers/time');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _helpers = require('redux/saga/helpers');

var _bound = require('redux/saga/entities/bound');

var _Login = require('features/Login/Login.route');

var _filters = require('./filters/filters.helpers');

var _SearchLocation = require('./models/SearchLocation');

var _filters2 = require('./filters/filters.saga');

var _Search = require('./Search.route');

var _SearchBox = require('./SearchBox/SearchBox.reducer');

var _Search2 = require('./Search.constants');

var _Search3 = require('./Search.reducer');

var _Search4 = require('./Search.helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doTrackMapViewToggle),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(buildSearchRequestPayload),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(resetFilters),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(trackSearchQuery),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(loadResults),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(loadResultsFromUrl),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(doFilterChanged),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(reloadResults),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(handleUrlChange),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(handleReservationStatusChanged),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(handlePageChange),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(hasLocationBeenSet),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(loadSearchHeader),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(initializeUserLocationForSearch),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(loadSearch),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(doShowMapForMobileLoggedOut),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(doShowAllVenues),
    _marked18 = /*#__PURE__*/_regenerator2.default.mark(watchSearch);

var ACTIVITY = _Search2.FILTER_NAMES.ACTIVITY,
    AMENITY = _Search2.FILTER_NAMES.AMENITY,
    DATE = _Search2.FILTER_NAMES.DATE,
    RADIUS = _Search2.FILTER_NAMES.RADIUS,
    RESULT_TYPE = _Search2.FILTER_NAMES.RESULT_TYPE,
    TIME = _Search2.FILTER_NAMES.TIME,
    VERTICAL = _Search2.FILTER_NAMES.VERTICAL,
    TO_TIME = _Search2.FILTER_NAMES.TO_TIME,
    FROM_TIME = _Search2.FILTER_NAMES.FROM_TIME,
    MAP_BOUNDS = _Search2.FILTER_NAMES.MAP_BOUNDS,
    LEVEL = _Search2.FILTER_NAMES.LEVEL;
var loadPage = exports.loadPage = function loadPage(delta) {
  return { type: 'classpass/search/LOAD_PAGE', delta: delta };
};
var showAllVenues = exports.showAllVenues = function showAllVenues() {
  return { type: 'classpass/search/SHOW_ALL_VENUES' };
};
var reloadSearch = exports.reloadSearch = function reloadSearch() {
  return { type: 'classpass/search/RELOAD_SEARCH' };
};

var selectSearchLocationChange = exports.selectSearchLocationChange = function selectSearchLocationChange(action) {
  return action.type === _reactRouterRedux.LOCATION_CHANGE && action.payload.pathname.indexOf(_Search.PATH) === 0;
};
var selectIsToggleMapView = exports.selectIsToggleMapView = function selectIsToggleMapView(action) {
  return action.type === _Search3.TOGGLE_MAP_VIEW;
};
var selectIsClientChange = exports.selectIsClientChange = function selectIsClientChange(action) {
  return action.type === _device.SET_IS_CLIENT;
};

function doTrackMapViewToggle() {
  var isMapView;
  return _regenerator2.default.wrap(function doTrackMapViewToggle$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_Search3.selectMapView);

        case 2:
          isMapView = _context.sent;

          if (!isMapView) {
            _context.next = 8;
            break;
          }

          _context.next = 6;
          return (0, _effects.call)(_multitrack.ec, _Search2.EVENTS.viewMap);

        case 6:
          _context.next = 10;
          break;

        case 8:
          _context.next = 10;
          return (0, _effects.call)(_multitrack.ec, _Search2.EVENTS.viewSchedules);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function buildSearchRequestPayload() {
  var _ref, _ref2, filters, location, searchBoxKeywordId, resultType, vertical, filterPayload, timeRange, _timeRange$split, _timeRange$split2, ft, tt;

  return _regenerator2.default.wrap(function buildSearchRequestPayload$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH), (0, _effects.select)(_SearchBox.selectActiveLocation), (0, _effects.select)(_SearchBox.selectSelectedKeywordId), (0, _effects.call)(_filters2.getResultType), (0, _effects.select)(_filters.selectSelectedVertical)]);

        case 2:
          _ref = _context2.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 5);
          filters = _ref2[0];
          location = _ref2[1];
          searchBoxKeywordId = _ref2[2];
          resultType = _ref2[3];
          vertical = _ref2[4];
          filterPayload = (0, _extends3.default)({}, vertical !== _Search2.VERTICALS.all && { vertical: vertical }, { // To get results with all verticals we must omit the verticals key
            date: (0, _deep.deepExtract)(DATE + '.value', filters) || (0, _time.timezoneDate)((0, _deep.deepExtract)('timezone', location)),
            tag: searchBoxKeywordId ? [searchBoxKeywordId] : (0, _keys2.default)((0, _deep.deepExtract)(ACTIVITY + '.itemIdSelected', filters, {})),
            lat: location.lat,
            lon: location.lon,
            place_id: location.placeId,
            result_type: resultType
          }, (0, _deep.deepExtract)(AMENITY + '.itemIdSelected', filters, {}), (0, _deep.deepExtract)(LEVEL + '.itemIdSelected', filters, {}));


          if (location.mapBounds) {
            filterPayload.map_bounds = location.mapBounds;
          } else {
            filterPayload.radius = (0, _filters2.getSelectedRadius)(filters);
          }

          timeRange = (0, _deep.deepExtract)(TIME + '.value', filters);

          if (timeRange && timeRange !== _filters2.TIME_DEFAULT) {
            _timeRange$split = timeRange.split('-'), _timeRange$split2 = (0, _slicedToArray3.default)(_timeRange$split, 2), ft = _timeRange$split2[0], tt = _timeRange$split2[1];

            filterPayload.ft = ft;
            filterPayload.tt = tt;
          }

          return _context2.abrupt('return', { search_request: { filters: filterPayload } });

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function resetFilters(filtersToOmit) {
  return _regenerator2.default.wrap(function resetFilters$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _Search3.setFilteringDisabled)(true));

        case 2:
          _context3.next = 4;
          return (0, _effects.put)(_filters.searchFilterActions.clearFilterSet(filtersToOmit));

        case 4:
          _context3.next = 6;
          return (0, _effects.put)((0, _Search3.setFilteringDisabled)(false));

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function trackSearchQuery(result, filters) {
  var keywordAutoCompleteEntry, locationAutocompleteEntry, schedules, creditAmounts, selectedLocation, mapBoundsFilter, splitMapBounds, searchId, keywordHeaderType, locationHeaderType, placeId, centerLat, centerLon, _ref3, _ref4, maxCredits, minCredits, _ref5, _ref6, mapViewPortSouthWestLon, mapViewportSouthWestLat, mapViewportNorthEastLon, mapViewportNorthEastLat;

  return _regenerator2.default.wrap(function trackSearchQuery$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          keywordAutoCompleteEntry = (0, _Search4.selectKeywordAutocompleteEntryInLayout)(result);
          locationAutocompleteEntry = (0, _Search4.selectLocationAutocompleteEntryInLayout)(result);
          schedules = (0, _Search4.selectSchedulesInLayout)(result) || [];
          creditAmounts = schedules.filter(function (schedule) {
            return schedule.availability && schedule.availability.credits;
          }).map(function (schedule) {
            return schedule.availability.credits;
          });
          _context4.next = 6;
          return (0, _effects.select)(_SearchBox.selectSelectedLocation);

        case 6:
          selectedLocation = _context4.sent;
          mapBoundsFilter = filters[MAP_BOUNDS];
          splitMapBounds = mapBoundsFilter && mapBoundsFilter.split(',');
          searchId = (0, _Search4.selectSearchIdInLayout)(result);
          keywordHeaderType = keywordAutoCompleteEntry.type;
          locationHeaderType = selectedLocation && selectedLocation.type;
          placeId = locationAutocompleteEntry.place_id;
          centerLat = locationAutocompleteEntry.lat;
          centerLon = locationAutocompleteEntry.lon;
          _ref3 = creditAmounts.length > 0 ? [Math.max.apply(Math, (0, _toConsumableArray3.default)(creditAmounts)), Math.min.apply(Math, (0, _toConsumableArray3.default)(creditAmounts))] : [], _ref4 = (0, _slicedToArray3.default)(_ref3, 2), maxCredits = _ref4[0], minCredits = _ref4[1];
          _ref5 = splitMapBounds || [], _ref6 = (0, _slicedToArray3.default)(_ref5, 4), mapViewPortSouthWestLon = _ref6[0], mapViewportSouthWestLat = _ref6[1], mapViewportNorthEastLon = _ref6[2], mapViewportNorthEastLat = _ref6[3];
          _context4.t0 = _effects.all;
          _context4.t1 = (0, _effects.put)((0, _Search3.setSearchId)(searchId));
          _context4.t2 = _effects.call;
          _context4.t3 = _multitrack.ec;
          _context4.t4 = _Search2.EVENTS.searchQuery;
          _context4.t5 = searchId;
          _context4.t6 = filters[VERTICAL];
          _context4.t7 = (0, _stringify2.default)(filters);
          _context4.next = 27;
          return (0, _effects.select)(_selectors.filterSetFilterValue, _filterSets.SEARCH, RESULT_TYPE);

        case 27:
          _context4.t8 = _context4.sent;
          _context4.next = 30;
          return (0, _effects.select)(_SearchBox.selectKeywordSearchBoxText);

        case 30:
          _context4.t9 = _context4.sent;
          _context4.next = 33;
          return (0, _effects.select)(_SearchBox.selectLocationSearchBoxText);

        case 33:
          _context4.t10 = _context4.sent;
          _context4.t11 = keywordHeaderType;
          _context4.t12 = locationHeaderType;
          _context4.t13 = placeId;
          _context4.t14 = filters[RADIUS];
          _context4.t15 = mapViewportNorthEastLat;
          _context4.t16 = mapViewportNorthEastLon;
          _context4.t17 = mapViewportSouthWestLat;
          _context4.t18 = mapViewPortSouthWestLon;
          _context4.t19 = centerLat;
          _context4.t20 = centerLon;
          _context4.t21 = filters[ACTIVITY];
          _context4.t22 = filters[TO_TIME];
          _context4.t23 = filters[FROM_TIME];
          _context4.t24 = minCredits;
          _context4.t25 = maxCredits;
          _context4.t26 = {
            search_id: _context4.t5,
            category: _context4.t6,
            selection: _context4.t7,
            result_type: _context4.t8,
            keyword_box_text: _context4.t9,
            location_box_text: _context4.t10,
            keyword_header_type: _context4.t11,
            location_header_type: _context4.t12,
            place_id: _context4.t13,
            radius: _context4.t14,
            map_view_north_east_lat: _context4.t15,
            map_view_north_east_lon: _context4.t16,
            map_view_south_west_lat: _context4.t17,
            map_view_south_west_lon: _context4.t18,
            map_center_lat: _context4.t19,
            map_center_lon: _context4.t20,
            activity: _context4.t21,
            tt: _context4.t22,
            ft: _context4.t23,
            min_credits: _context4.t24,
            max_credits: _context4.t25
          };
          _context4.t27 = (0, _context4.t2)(_context4.t3, _context4.t4, _context4.t26);
          _context4.t28 = [_context4.t1, _context4.t27];
          _context4.next = 54;
          return (0, _context4.t0)(_context4.t28);

        case 54:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadResults(client) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var payload = arguments[2];

  var previousPageData, cursor, distanceUnit, _ref7, _ref8, result, filtersFromHash, venues, searchFilters, selectedRadiusId, selectedLocation, currentTimezone, updatedLayout, timezoneFromLayout;

  return _regenerator2.default.wrap(function loadResults$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(!payload && page === 1)) {
            _context5.next = 6;
            break;
          }

          _context5.next = 3;
          return (0, _effects.call)(buildSearchRequestPayload, client);

        case 3:
          payload = _context5.sent;
          _context5.next = 14;
          break;

        case 6:
          if (payload) {
            _context5.next = 14;
            break;
          }

          _context5.next = 9;
          return (0, _effects.select)(_Search4.selectResultsFromLayout, page - 1);

        case 9:
          previousPageData = _context5.sent;
          cursor = (0, _Search4.selectCursorInLayout)(previousPageData);

          payload = {
            search_request: { cursor: cursor },
            modules: (0, _keys2.default)(previousPageData) // fetch the same modules
          };
          _context5.next = 14;
          return (0, _effects.put)((0, _Search3.setReloadCursor)(cursor));

        case 14:
          _context5.next = 16;
          return (0, _effects.select)(_locale.selectDistanceUnit);

        case 16:
          distanceUnit = _context5.sent;
          _context5.next = 19;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntity, _bound.searchLayoutByName, [client, _Search2.RESULTS_LAYOUT, payload, { distanceUnit: distanceUnit }], {
            key: _Search2.RESULTS_LAYOUT + '_' + page
          }), (0, _effects.put)((0, _Search3.setCurrentPage)(page))]);

        case 19:
          _ref7 = _context5.sent;
          _ref8 = (0, _slicedToArray3.default)(_ref7, 1);
          result = _ref8[0];
          _context5.next = 24;
          return (0, _effects.select)(_Search4.selectFiltersFromSearchResults);

        case 24:
          filtersFromHash = _context5.sent;

          if (!(filtersFromHash.result_type === _Search2.RESULT_TYPES.VENUE)) {
            _context5.next = 29;
            break;
          }

          venues = (0, _Search4.selectVenuesInLayout)(result) || [];
          _context5.next = 29;
          return (0, _effects.put)((0, _Search3.setVisibleVenues)(venues.slice(0, _Search2.INITIAL_VISIBLE_VENUE_COUNT)));

        case 29:
          _context5.next = 31;
          return (0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH);

        case 31:
          searchFilters = _context5.sent;
          selectedRadiusId = (0, _deep.deepExtract)(RADIUS + '.value', searchFilters);

          if (selectedRadiusId) {
            _context5.next = 36;
            break;
          }

          _context5.next = 36;
          return (0, _effects.call)(_filters2.doLoadRadius);

        case 36:
          _context5.next = 38;
          return (0, _effects.select)(_SearchBox.selectSelectedLocation);

        case 38:
          selectedLocation = _context5.sent;

          if (!selectedLocation) {
            _context5.next = 50;
            break;
          }

          currentTimezone = selectedLocation && selectedLocation.timezone;
          _context5.next = 43;
          return (0, _effects.select)(_Search4.selectResultsFromLayout);

        case 43:
          updatedLayout = _context5.sent;
          _context5.next = 46;
          return (0, _effects.call)(_Search4.selectLocationAutocompleteTimezoneInLayout, updatedLayout);

        case 46:
          timezoneFromLayout = _context5.sent;

          if (!(!currentTimezone && timezoneFromLayout)) {
            _context5.next = 50;
            break;
          }

          _context5.next = 50;
          return (0, _effects.put)((0, _SearchBox.setLocationTimezone)(timezoneFromLayout));

        case 50:
          return _context5.abrupt('return', {
            result: result,
            filters: payload.search_request.filters
          });

        case 51:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadResultsFromUrl(client, url) {
  var _ref9, _ref10, existingFilters, location, _ref11, result, filters;

  return _regenerator2.default.wrap(function loadResultsFromUrl$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH), (0, _effects.select)(_SearchBox.selectActiveLocation)]);

        case 2:
          _ref9 = _context6.sent;
          _ref10 = (0, _slicedToArray3.default)(_ref9, 2);
          existingFilters = _ref10[0];
          location = _ref10[1];
          _context6.next = 8;
          return (0, _effects.call)(loadResults, client, 1, {
            search_request: {
              hash: url,
              filters: {
                date: (0, _deep.deepExtract)(DATE + '.value', existingFilters) || (0, _time.timezoneDate)((0, _deep.deepExtract)('timezone', location))
              }
            }
          });

        case 8:
          _ref11 = _context6.sent;
          result = _ref11.result;
          filters = _ref11.filters;
          _context6.next = 13;
          return (0, _effects.put)((0, _Search3.setActiveUrl)(url));

        case 13:
          _context6.next = 15;
          return (0, _effects.put)((0, _Search3.setFiltersFromHash)());

        case 15:
          return _context6.abrupt('return', {
            result: result,
            filters: filters
          });

        case 16:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doFilterChanged(client, action) {
  var _ref12, result, filters, searchUrl, actionData, filterName, filterNames, allFilterNames;

  return _regenerator2.default.wrap(function doFilterChanged$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(_Search3.selectFilteringDisabled);

        case 2:
          if (!_context7.sent) {
            _context7.next = 4;
            break;
          }

          return _context7.abrupt('return');

        case 4:
          _context7.next = 6;
          return (0, _effects.call)(loadResults, client, 1);

        case 6:
          _ref12 = _context7.sent;
          result = _ref12.result;
          filters = _ref12.filters;
          _context7.next = 11;
          return (0, _effects.spawn)(trackSearchQuery, result, filters);

        case 11:
          searchUrl = (0, _Search4.makeUrlFromLayout)(result);

          if (!searchUrl) {
            _context7.next = 15;
            break;
          }

          _context7.next = 15;
          return (0, _effects.all)([(0, _effects.put)((0, _Search3.setActiveUrl)(searchUrl)), (0, _effects.put)((0, _reactRouterRedux.push)(searchUrl))]);

        case 15:
          actionData = action && (action.data || action);
          filterName = actionData.filter, filterNames = actionData.filters;
          allFilterNames = filterNames || filterName && [filterName];

          if (!allFilterNames) {
            _context7.next = 21;
            break;
          }

          _context7.next = 21;
          return (0, _effects.put)(_filters.searchFilterActions.resetNeedsUpdate(allFilterNames));

        case 21:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function reloadResults(client) {
  var currentPage, payload, previousPageData, cursor;
  return _regenerator2.default.wrap(function reloadResults$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(_Search3.selectCurrentPage);

        case 2:
          currentPage = _context8.sent;
          payload = void 0;

          if (!(currentPage > 1)) {
            _context8.next = 12;
            break;
          }

          _context8.next = 7;
          return (0, _effects.select)(_Search4.selectResultsFromLayout, currentPage);

        case 7:
          previousPageData = _context8.sent;
          _context8.next = 10;
          return (0, _effects.select)(_Search3.selectReloadCursor);

        case 10:
          cursor = _context8.sent;

          payload = {
            search_request: { cursor: cursor },
            modules: (0, _keys2.default)(previousPageData)
          };

        case 12:
          _context8.next = 14;
          return (0, _effects.call)(loadResults, client, currentPage, payload);

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function handleUrlChange(client, action) {
  var newUrl, activeUrl;
  return _regenerator2.default.wrap(function handleUrlChange$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          newUrl = action.payload.pathname;
          _context9.next = 3;
          return (0, _effects.select)(_Search3.selectActiveUrl);

        case 3:
          activeUrl = _context9.sent;

          if (!(newUrl === activeUrl)) {
            _context9.next = 6;
            break;
          }

          return _context9.abrupt('return');

        case 6:
          if (!(newUrl === _Search.PATH)) {
            _context9.next = 13;
            break;
          }

          _context9.next = 9;
          return (0, _effects.call)(resetFilters);

        case 9:
          _context9.next = 11;
          return (0, _effects.call)(loadResults, client);

        case 11:
          _context9.next = 15;
          break;

        case 13:
          _context9.next = 15;
          return (0, _effects.call)(loadResultsFromUrl, client, newUrl);

        case 15:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function handleReservationStatusChanged(client) {
  var _ref13, _ref14, date, isViewingNextCycle, userId, location;

  return _regenerator2.default.wrap(function handleReservationStatusChanged$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_selectors.filterSetFilterValue, _filterSets.SEARCH, DATE), (0, _effects.select)(_selectors.viewingNextCycle), (0, _effects.call)(_helpers.getUserId, client), (0, _effects.select)(_SearchBox.selectActiveLocation)]);

        case 2:
          _ref13 = _context10.sent;
          _ref14 = (0, _slicedToArray3.default)(_ref13, 4);
          date = _ref14[0];
          isViewingNextCycle = _ref14[1];
          userId = _ref14[2];
          location = _ref14[3];
          _context10.next = 10;
          return (0, _effects.all)([(0, _effects.call)(reloadResults, client), (0, _effects.call)(_sagaTools.fetchEntity, _bound.userCreditBalance, [client, userId, { applicable_on: date || (0, _time.timezoneDate)((0, _deep.deepExtract)('timezone', location)) }, isViewingNextCycle])]);

        case 10:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function handlePageChange(client, _ref15) {
  var delta = _ref15.delta;
  var currentPage, nextPage;
  return _regenerator2.default.wrap(function handlePageChange$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(_Search3.selectCurrentPage);

        case 2:
          currentPage = _context11.sent;
          nextPage = currentPage + delta;
          _context11.next = 6;
          return (0, _effects.all)([(0, _effects.call)(_helpers.scrollToTop), (0, _effects.call)(loadResults, client, nextPage)]);

        case 6:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function hasLocationBeenSet() {
  var _ref16, _ref17, hasDefaultLocation, hasSelectedLocation;

  return _regenerator2.default.wrap(function hasLocationBeenSet$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_SearchBox.selectDefaultLocation), (0, _effects.select)(_SearchBox.selectSelectedLocation)]);

        case 2:
          _ref16 = _context12.sent;
          _ref17 = (0, _slicedToArray3.default)(_ref16, 2);
          hasDefaultLocation = _ref17[0];
          hasSelectedLocation = _ref17[1];
          return _context12.abrupt('return', !!hasDefaultLocation || !!hasSelectedLocation);

        case 7:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function loadSearchHeader(client) {
  var _ref18, lat, lon;

  return _regenerator2.default.wrap(function loadSearchHeader$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.select)(_Search4.getUserLocationForSearch);

        case 2:
          _ref18 = _context13.sent;
          lat = _ref18.lat;
          lon = _ref18.lon;
          _context13.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.searchLayoutByName, [client, _Search2.HEADER_LAYOUT, {
            header_request: { location: { lat: lat, lon: lon } }
          }]);

        case 7:
          return _context13.abrupt('return', _context13.sent);

        case 8:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function initializeUserLocationForSearch(client) {
  var _ref19, lat, lon, defaultLocation, searchResultsData, _ref20, _ref21, place_id, name, timezone, searchHeaderData, headerLocation;

  return _regenerator2.default.wrap(function initializeUserLocationForSearch$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.put)((0, _Search3.setFilteringDisabled)(true));

        case 2:
          _context14.next = 4;
          return (0, _effects.select)(_Search4.selectFiltersFromSearchResults);

        case 4:
          _ref19 = _context14.sent;
          lat = _ref19.lat;
          lon = _ref19.lon;
          defaultLocation = void 0;

          if (!(lat && lon)) {
            _context14.next = 22;
            break;
          }

          _context14.next = 11;
          return (0, _effects.select)(_Search4.selectResultsFromLayout);

        case 11:
          searchResultsData = _context14.sent;
          _context14.next = 14;
          return (0, _effects.all)([// eslint-disable-line camelcase
          (0, _effects.select)(_Search4.selectLocationAutocompleteFromSearchResults), (0, _effects.call)(_Search4.selectLocationAutocompleteValueInLayout, searchResultsData), (0, _effects.call)(_Search4.selectLocationAutocompleteTimezoneInLayout, searchResultsData)]);

        case 14:
          _ref20 = _context14.sent;
          _ref21 = (0, _slicedToArray3.default)(_ref20, 3);
          place_id = _ref21[0].place_id;
          name = _ref21[1];
          timezone = _ref21[2];

          defaultLocation = new _SearchLocation.SearchLocation({ lat: lat, lon: lon, name: name, place_id: place_id, timezone: timezone }); // eslint-disable-line object-curly-newline
          _context14.next = 27;
          break;

        case 22:
          _context14.next = 24;
          return (0, _effects.call)(loadSearchHeader, client);

        case 24:
          searchHeaderData = _context14.sent;
          headerLocation = (0, _deep.deepExtract)('location_history.data.default_location', searchHeaderData, _Search2.DEFAULT_GEOLOCATION);

          defaultLocation = new _SearchLocation.SearchLocation(headerLocation);

        case 27:
          _context14.next = 29;
          return (0, _effects.put)((0, _SearchBox.setDefaultLocation)(defaultLocation));

        case 29:
          _context14.next = 31;
          return (0, _effects.put)((0, _Search3.setFilteringDisabled)(false));

        case 31:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function loadSearch(client) {
  var url, result, filters, _ref22, searchResultType, loggedIn, correctUrl, _ref23, shouldShowNewMap;

  return _regenerator2.default.wrap(function loadSearch$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.select)(_selectors.pathSelector);

        case 3:
          url = _context15.sent;
          _context15.next = 6;
          return (0, _effects.call)(initializeUserLocationForSearch, client);

        case 6:
          result = void 0;
          filters = void 0;

          if (!(url !== _Search.PATH)) {
            _context15.next = 34;
            break;
          }

          _context15.next = 11;
          return (0, _effects.call)(loadResultsFromUrl, client, url);

        case 11:
          _ref22 = _context15.sent;
          filters = _ref22.filters;
          result = _ref22.result;
          _context15.next = 16;
          return (0, _effects.select)(_Search4.selectResultTypeFromSearchResults);

        case 16:
          searchResultType = _context15.sent;

          if (!(searchResultType && searchResultType === _Search2.RESULT_TYPES.SCHEDULE)) {
            _context15.next = 25;
            break;
          }

          _context15.next = 20;
          return (0, _effects.select)(_user.isLoggedIn);

        case 20:
          loggedIn = _context15.sent;

          if (loggedIn) {
            _context15.next = 25;
            break;
          }

          _context15.next = 24;
          return (0, _effects.put)((0, _reactRouterRedux.replace)((0, _Login.LoginRoute)().path + '/?returnTo=' + encodeURIComponent(url)));

        case 24:
          return _context15.abrupt('return', _context15.sent);

        case 25:
          _context15.next = 27;
          return (0, _effects.call)(_Search4.makeUrlFromLayout, result);

        case 27:
          correctUrl = _context15.sent;

          if (!(url !== correctUrl)) {
            _context15.next = 32;
            break;
          }

          _context15.next = 31;
          return (0, _effects.put)((0, _reactRouterRedux.replace)({
            pathname: correctUrl,
            state: { status: 301 }
          }));

        case 31:
          return _context15.abrupt('return', _context15.sent);

        case 32:
          _context15.next = 39;
          break;

        case 34:
          _context15.next = 36;
          return (0, _effects.call)(loadResults, client, 1);

        case 36:
          _ref23 = _context15.sent;
          filters = _ref23.filters;
          result = _ref23.result;

        case 39:
          _context15.next = 41;
          return (0, _effects.call)(_helpers.userHasPermission, client, 'classpass_staff');

        case 41:
          shouldShowNewMap = _context15.sent;
          _context15.next = 44;
          return (0, _effects.put)((0, _Search3.setShouldShowNewMap)(shouldShowNewMap));

        case 44:
          _context15.next = 46;
          return (0, _effects.spawn)(trackSearchQuery, result, filters);

        case 46:
          _context15.next = 51;
          break;

        case 48:
          _context15.prev = 48;
          _context15.t0 = _context15['catch'](0);

          logger.error('Error loading search', _context15.t0.message);

        case 51:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this, [[0, 48]]);
}

function doShowMapForMobileLoggedOut() {
  var _ref24, _ref25, isUserLoggedIn, isUserOnMobileDevice;

  return _regenerator2.default.wrap(function doShowMapForMobileLoggedOut$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.all)([(0, _effects.select)(_user.isLoggedIn), (0, _effects.call)(_isMobile.isMobileDevice)]);

        case 2:
          _ref24 = _context16.sent;
          _ref25 = (0, _slicedToArray3.default)(_ref24, 2);
          isUserLoggedIn = _ref25[0];
          isUserOnMobileDevice = _ref25[1];

          if (!(isUserOnMobileDevice && !isUserLoggedIn)) {
            _context16.next = 9;
            break;
          }

          _context16.next = 9;
          return (0, _effects.put)((0, _Search3.setMapView)(true));

        case 9:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this);
}

function doShowAllVenues() {
  var results, venues;
  return _regenerator2.default.wrap(function doShowAllVenues$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(_Search4.selectResultsFromLayout);

        case 2:
          results = _context17.sent;
          _context17.next = 5;
          return (0, _Search4.selectVenuesInLayout)(results);

        case 5:
          venues = _context17.sent;
          _context17.next = 8;
          return (0, _effects.put)((0, _Search3.setVisibleVenues)(venues));

        case 8:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this);
}

function watchSearch(client) {
  return _regenerator2.default.wrap(function watchSearch$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(_effects.takeEvery, selectIsToggleMapView, doTrackMapViewToggle), (0, _effects.fork)(_effects.takeLatest, (0, _Reservation.reservationStatusChanged)().type, handleReservationStatusChanged, client), (0, _effects.fork)(_effects.takeLatest, loadPage().type, handlePageChange, client), (0, _effects.fork)(_effects.takeLatest, showAllVenues().type, doShowAllVenues), (0, _effects.fork)(_effects.takeLatest, selectSearchLocationChange, handleUrlChange, client), (0, _effects.fork)(_effects.takeLatest, selectIsClientChange, doShowMapForMobileLoggedOut), (0, _effects.fork)(_effects.takeLatest, reloadSearch().type, reloadResults, client), (0, _effects.fork)(_effects.takeLatest, [_filters.selectSearchFilterWriteActions, (0, _filters2.filterChanged)().type, (0, _filters2.filtersChanged)().type, _SearchBox.SET_KEYWORD, _SearchBox.CLEAR_KEYWORD, _SearchBox.CLEAR_LOCATION], doFilterChanged, client)]);

        case 2:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}